import {recordPaneOpen, setCurrentPane, setPrevPane} from "./commit_helpers";

export function openPaneComponent(sm, newPane) {
    // Opening the pane that's already current changes nothing, so it isn't counted as an open. The Nav
    // can name a different pane to compare against (`Nav#withPaneOpenBaseline`, the initial deep link).
    const nav = typeof sm.getStateableObject === 'function' ? sm.getStateableObject() : null;
    const baselinePaneId = nav && nav.paneOpenBaselineId !== undefined ? nav.paneOpenBaselineId : sm.state['currentPaneId'];
    const paneChanged = baselinePaneId !== newPane.identifier;

    setPrevPane(sm, newPane);

    // Before Callbacks
    fireBeforeBlurPaneCallback(sm, newPane);
    fireBeforeFocusPaneCallback(sm, newPane);

    setCurrentPane(sm, newPane);

    // After Callbacks
    fireAfterBlurPaneCallback(sm, newPane);
    fireAfterFocusPaneCallback(sm, newPane, { paneChanged });

    recordPaneOpen(sm, newPane);
}




// Private…

// When the current pane is about to change we call the before focus callback.
function fireBeforeFocusPaneCallback(sm, pane) {
    if (sm.state['currentPaneId'] !== pane.identifier) {
        if (pane.onBeforeFocus) pane.onBeforeFocus();
    }
}

// When the current pane is about to loose focus (blur) we call its before blur callback.
function fireBeforeBlurPaneCallback(sm, newPane) {
    let oldPane = getPaneByIdentifier(sm.state['currentPaneId'], newPane.getPanesManager());
    if (oldPane && newPane.identifier !== oldPane.identifier) {
        if (oldPane.onBeforeBlur) oldPane.onBeforeBlur();
    }
}

// When the previous pane has just lost focus (blur) we call its after blur callback.
function fireAfterBlurPaneCallback(sm, newPane) {
    let oldPane = getPaneByIdentifier(sm.state['prevPaneId'], newPane.getPanesManager());
    if (oldPane && newPane.identifier !== oldPane.identifier) {
        if (oldPane.onAfterBlur) oldPane.onAfterBlur();
    }
}

// When the current pane has just changed we call the after focus callback.
// It also runs when re-opening the current pane (whenever `prevPaneId` is another pane); `focus.paneChanged`
// tells the callbacks which case it is.
function fireAfterFocusPaneCallback(sm, pane, focus) {
    if (sm.state['currentPaneId'] == pane.identifier && sm.state['prevPaneId'] !== pane.identifier) {
        if (pane.onAfterFocus) pane.onAfterFocus(focus);
    }
}


function getPaneByIdentifier(identifier, panesManager) {
    if (identifier && panesManager) return panesManager.findPaneByIdentifier(identifier);
}